// extracted by mini-css-extract-plugin
export default {"main":"LoadingSpinner_main__zio91","spinner":"LoadingSpinner_spinner__uKPbU"};